<template>
  <v-dialog v-model="dialog"  persistent :overlay="false" max-width="800px" transition="dialog-transition">
    <v-snackbar v-model="snackErreur" color="red">
      {{snackErreurMessage}}
      <v-btn text color="white" @click.native="snackErreur = false">fermer</v-btn>
    </v-snackbar>

    <v-card>

      <v-card-title primary-title v-if="!creation">
        {{ $tr.container.editPopupTitle }} {{aContainer.ctContainer}}
      </v-card-title>

      <v-card-title primary-title v-if="creation">
        {{ $tr.container.addPopupTitle }}
      </v-card-title>

      <v-card-text>
        <v-form v-model="valid">
          <h-group style="align-items: start;">
            
            <v-group class="pa-5 mr-4" style="background-color: #F0F0F0;  width: 400px; align-items: stretch">
              <v-text-field name="ctContainer" :rules="nameRules" required :label="$tr.container.t1" autofocus v-model="aContainer.ctContainer" v-if="creation"></v-text-field> <!-- Numéro unique de conteneur --> 
              <v-text-field name="ctScac" :label="$tr.container.t2" v-model="aContainer.ctScac"></v-text-field> <!-- Scac -->
              <v-text-field name="ctStatut" :label="$tr.container.t3" v-model="aContainer.ctStatut"></v-text-field>  <!-- Statut -->
              <v-text-field name="ctType" :label="$tr.container.t4" v-model="aContainer.ctType"></v-text-field> <!-- Type --> 
              <v-text-field name="ctPoids" :label="$tr.container.t5" v-model="aContainer.ctPoids"></v-text-field> <!-- Poids (kg) --> 
              <v-text-field name="ctTare" :label="$tr.container.t6" v-model="aContainer.ctTare"></v-text-field> <!-- Tare (kg) -->
            </v-group>
            
            <v-group class="pa-5 mr-4" style="background-color: #F0F0F0; width: 400px;align-items: stretch">
              <v-checkbox :label="$tr.container.t7" v-model="present"></v-checkbox> <!-- Présent ou non -->
              <v-text-field name="ctDateArrival" type="date" :label="$tr.container.t8" v-model="dateArrival" v-if="present"></v-text-field> <!-- Date arrivée --> 
              <v-text-field name="ctDateDeparture" type="date" :label="$tr.container.t9" v-model="dateDeparture" v-if="!present"></v-text-field> <!-- Date départ --> 
              <h-group>
                <div class="mr-3">{{ $tr.container.pretransport }}</div>
                <v-radio-group row v-model="aContainer.ctPreacheminement">
                  <v-radio :label="$tr.container.train" value="Train"></v-radio>
                  <v-radio :label="$tr.container.route" value="Route"></v-radio>
                </v-radio-group>
              </h-group>
              <v-text-field name="ctEtat" :label="$tr.container.t10" v-model="aContainer.ctEtat"></v-text-field> <!-- Etat -->
              <v-checkbox :label="$tr.container.t11" v-model="aContainer.ctKitIsolation"></v-checkbox> <!-- Kit isolation -->
            </v-group>

            <v-group class="pa-5" style="background-color: #F0F0F0;  width: 400px; align-items: stretch">
              <v-text-field name="ctExpedition" :label="$tr.container.t12" v-model="aContainer.ctExpedition"></v-text-field> <!-- N° commande NW -->
              <v-text-field name="ctSeal" :label="$tr.container.t13" v-model="aContainer.ctSeal"></v-text-field>  <!-- Seal -->
              <v-text-field name="ctNestleBookingNumber" :label="$tr.container.t14" v-model="aContainer.ctNestleBookingNumber"></v-text-field> <!-- NW booking number -->
            </v-group>

          </h-group>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="$emit('fermer')">{{ $tr.dialogCommon.cancel }}</v-btn>
        <v-btn color="success" @click="boutonOkClickEvent()" :loading="loading" :disabled="!valid">{{ $tr.dialogCommon.ok }}</v-btn>
      </v-card-actions>
    </v-card>
    
  </v-dialog>
</template>

<script>
export default {

  data() {
    return {
      loading: false,
      snackErreur: false,
      snackErreurMessage: "",
      aContainer: new Object(),
      present: false,
      dateArrival: null,
      dateDeparture: null,
      creation: false,
      valid: false,
      preacheminement: "Train",
      nameRules: [
        v => !!v || this.$tr.errorCommon.mandatoryField,
        v => this.checkNomConteneur(v) || this.$tr.container.nameError,
      ],
    }
  },

  props: {
    container: {
      type: Object
    },
    dialog: {
      type: Boolean,
      default: false
    }
  },

  watch: {
    'dialog': {
      handler(newVal) {
        if (newVal) {
          // Initialisation
          this.aContainer = new Object();
          for(var key in this.container)
            this.aContainer[key] = this.container[key];
          const present = (this.aContainer.ctDateArrival != undefined) && (this.aContainer.ctDateArrival != null)
          this.dateArrival = present ? this.aContainer.ctDateArrival.substr(0,10) : new Date().toISOString().substr(0,10);
          this.dateDeparture = !present ? this.aContainer.ctDateDeparture.substr(0,10) : new Date().toISOString().substr(0,10);
          this.preacheminement = this.aContainer.ctPreacheminement == "Route" ? "Route" : "Train";
          this.present = present;
          this.creation = this.aContainer.ctContainer == ""
          
        }
      }
    }
  },

  methods: {
    afficherErreur(message) {
      this.loading = false;
      this.snackErreurMessage = message;
      this.snackErreur = true;
    },

    boutonOkClickEvent() {
      if (!this.creation) {
        this.modifier();
      }
      else {
        this.creer();
      }
    },

    mettreAJourDates() {
      if (this.present) {
        this.aContainer.ctDateArrival = new Date(this.dateArrival).toISOString();
        this.aContainer.ctDateDeparture = null;
      }
      else {
        this.aContainer.ctDateDeparture = new Date(this.dateDeparture).toISOString();
        this.aContainer.ctDateArrival = null;
      }
    },

    creer() {
      // Contrôle de doublon de container
      const filter = {"where": {"ctContainer": this.aContainer.ctContainer}}
      var url = "/api/ctContainers/?access_token=" + this.$user.id + "&filter=" + JSON.stringify(filter);
      this.loading = true;
      this.$axios.get(url)
        .then(function (response) {
          if (response.data.length >= 1) {
            this.afficherErreur(this.$tr.container.thisContainer+ " " + this.aContainer.ctContainer + " " + this.$tr.container.alreadyExists);  
          }
          else {
            // Création du container dans la base de données
            this.mettreAJourDates();
            const url = "/api/ctContainers?access_token=" + this.$user.id;
            const body = this.aContainer;
            this.$axios.post(url, body)
              .then(function() {
                this.loading = false;
                this.$emit("containerCree", this.aContainer);
              }.bind(this))
              .catch(function (error) {
                this.afficherErreur(error.message + " " + error.response.statusText)
              }.bind(this))
          }
        }.bind(this))
        .catch(function(error) {
          this.afficherErreur(error.message + " " + error.response.statusText)
        }.bind(this))
    },

    modifier() {
      this.loading = true;
      this.mettreAJourDates();
      const url = "/api/ctContainers/" + this.aContainer.ctCtId + "?access_token=" + this.$user.id;
      const body = this.aContainer;
      this.$axios.put(url, body)
        .then(function() {
          this.loading = false;
          this.$emit("containerModifie", this.aContainer);
        }.bind(this))
        .catch(function (error) {
          this.afficherErreur(error.message + " " + error.response.statusText)
        }.bind(this))
    },

    /**
     * Contrôle du nom de conteneur
     * Le nom doit comporter 4 lettres suivies de 7 chiffres
     * @param {string} nom Nom du conteneur
     */
    checkNomConteneur(nom) {
      if (nom == undefined) {
        return false
      }
      if (nom.length == undefined) {
        return false
      }
      if (nom.length != 11) {
        return false
      }
      const p1 = nom.substr(0, 4)
      const r1 = /^[A-Z]+$/
      if (!r1.test(p1)) {
        return false
      }
      const p2 = nom.substr(4, 7)
      const r2 = /^[0-9]+$/
      return r2.test(p2)
    }
  }

}
</script>

<style>

</style>